import ContactPreview from './ContactPreview.component';

export default ContactPreview;
